import React from 'react'

import Layout from 'src/components/common/Layout'
import StatusTemplate from '../status'

const Template404 = ({ location }) => {
  return (
    <Layout location={location} market="404" noFooter noIndex>
      <StatusTemplate type="error" />
    </Layout>
  )
}

export default Template404
